import RenderComponent from '@/modules/DynamicRenderPage';
import { ROLES } from 'globalconfig/constants/keys';
import { getQueryStringKeys, hasRestrictedRole, isInsuracePortalUser, loadPageConfig, loadStyle } from 'globalutils/fmUtils';
import PropTypes from 'prop-types';
import React, { lazy, useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { generateFilterButtons, getFilterData } from './filterConfig';
import { checkServiceProvider } from './serviceProviderConfig';
import ParentStyled from './style';

const Styled = loadStyle(ParentStyled, 'pages/web/Users');
const config = loadPageConfig();
const Title = lazy(() => import(`globalcomponents/Title`));
const Content = lazy(() => import(`@/${config.userList[1].name}`));
const TopActions = config.userList[0].children && lazy(() => import(`${config.userList[0].children.name}`));
let timer;

const Users = (parentProps) => {
  const SERVICE_PROVIDER = window?.$environment?.SERVICE_PROVIDER;
  const { fetchUsers, getFilters, getDocumentToken, history, i18n, theme, module, filterData, users, fetchPaginatedUsers } =
    parentProps;

  const basicRequest = {
    displayLength: '10',
    displayStart: '1',
  };
  const [request, setRequest] = useState({
    ...basicRequest,
  });
  const commonParentProps = { history, i18n, Styled, theme };
  const [pagination, setPagination] = useState(false);
  const userRole = getQueryStringKeys(history.location.search, 'role');
  const isServiceManager = hasRestrictedRole([ROLES.SERVICE_MANAGER]);
  const RTFMuser = checkServiceProvider('rtfmUser', SERVICE_PROVIDER, false);
  const insuracePortalUserRole = isInsuracePortalUser();
  const searchConfig = {
    setPagination,
    searchPlaceholder: i18n.t('users.searchMechanic'),
    fromData: true,
    filterData,
    data: users?.list,
    query: ['full_name', 'email', 'empId'],
  };

  const [filterButtons, setButtons] = useState(
    generateFilterButtons({ i18n, userRole, isServiceManager, insuracePortalUserRole, RTFMuser })
  );


  const viewOnly = hasRestrictedRole([ROLES.VIEW_ONLY_FM]);

  useEffect(() => {
    if (insuracePortalUserRole) {
      fetchUsers({
        apiId: 'fetchUsers',
        ...(module === 'mechanicList' ? { userRole: 'MECHANIC' } : {}),
      });
    } else {
      fetchPaginatedUsers({
        apiId: 'fetchUsers',
        data: {
          request: module === 'mechanicList' ? { ...request, search: 'MECHANIC' } : request,
        },
      });
    }

    getFilters({ apiId: 'fetchFilters' });
    getDocumentToken({ apiId: 'getDocToken' });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const filterSuccess = (e) => {
    if (insuracePortalUserRole) {
      filterData(e);
    } else {
      clearTimeout(timer);
      timer = setTimeout(() => {
        fetchPaginatedUsers({
          apiId: 'fetchSearchUserApi',
          data: { request: { ...request, search: e } },
        });
      }, 500);
    }
  };

  useEffect(() => {
    if (!insuracePortalUserRole && JSON.stringify(request) != JSON.stringify(basicRequest)) {
      fetchPaginatedUsers({
        apiId: 'fetchUsersPaginateApi',
        data: { request: request },
      });
    }
  }, [request]);

  const sortColumnMapping = {
    email: 'email',
    full_name: 'fullName',
    empId: 'empId',
    status: 'status',
    last_login: 'lastLogin',
  };
  const [removeData, setremoveData] = useState('false');

  const changeRequest = (fields) => {
    if (fields?.sortCol) {
      const type = fields.sortCol;
      fields.sortCol = sortColumnMapping[type] ? sortColumnMapping[type] : fields.sortCol;
    }
    setRequest({ ...basicRequest, ...fields });
  };

  const setFilterData = (role) => {
    const search = getFilterData(role);
    setRequest({ ...basicRequest, search });
  };

  return (
    <>
      <RenderComponent
        {...config.userList[0]}
        parentProps={{
          ...parentProps,
          pagination,
          setPagination,
          setButtons,
          filterButtons,
          setremoveData,
          filterSuccess,
          removeData,
        }}
        {...(module === 'mechanicList'
          ? {
              header: 'users.mechanicListHeading',
            }
          : {})}
        commonParentProps={commonParentProps}
        component={Title}
        childComponent={TopActions}
        searchConfig={window.$environment.CURRENT_LAYOUT === 'SpireonNew' ? searchConfig : null}
      />
      <RenderComponent
        {...config.userList[1]}
        parentProps={{
          ...parentProps,
          changeRequest,
          request,
          setFilterData,
          filterSuccess,
        }}
        commonParentProps={commonParentProps}
        component={Content}
        filterButtons={filterButtons}
        setButtons={setButtons}
        pagination={pagination}
        setPagination={setPagination}
        setremoveData={setremoveData}
        removeData={removeData}
        viewOnly={viewOnly}
        viewExportOptions={module !== 'mechanicList'}
        showFilters={module !== 'mechanicList'}
        showAllUsers={module !== 'mechanicList'}
        isMechanicUser={module === 'mechanicList'}
      />
    </>
  );
};

const mapState = (state) => {
  return {
    apiStatus: state.asyncRequests,
    users: state.users,
    filters: state.filters,
    logBook: state.logBook,
  };
};
const mapDispatch = (dispatch) => {
  return {
    fetchUsers: (data) => dispatch.users.fetchData(data),
    fetchPaginatedUsers: (data) => dispatch.users.fetchPaginatedUsers(data),
    handleDeleteAlert: (data) => dispatch.users.handleDeleteAlert(data),
    handleResetPassword: (data) => dispatch.users.handleResetPassword(data),
    handleRestoreAlert: (data) => dispatch.users.handleRestoreAlert(data),
    filterData: (data) => dispatch.users.filterSuccess(data),
    handleExportUser: (data) => dispatch.users.handleExportUser(data),
    handleImportUser: (data) => dispatch.users.handleImportUser(data),
    handleExportUserTemplate: (data) => dispatch.users.handleExportUserTemplate(data),
    getFilters: (data) => dispatch.filters.fetchData(data),
    getDocumentToken: (data) => dispatch.logBook.documentToken(data),
  };
};

export default connect(mapState, mapDispatch)(Users);

Users.propTypes = {
  apiStatus: PropTypes.object.isRequired,
  users: PropTypes.object.isRequired,
  fetchUsers: PropTypes.func.isRequired,
  fetchPaginatedUsers: PropTypes.func.isRequired,
  handleDeleteAlert: PropTypes.func.isRequired,
  handleResetPassword: PropTypes.func.isRequired,
  handleRestoreAlert: PropTypes.func.isRequired,
  filterData: PropTypes.func.isRequired,
  handleExportUser: PropTypes.func.isRequired,
  handleImportUser: PropTypes.func.isRequired,
  handleExportUserTemplate: PropTypes.func.isRequired,
  filters: PropTypes.object.isRequired,
  getFilters: PropTypes.func.isRequired,
};
